<template>
  <div class="smAi">
    <div class="header x-flex x-row-between x-m-b-7">
      <div class="x-flex x-m-r-15">
        <el-radio v-model="radio" label="条件查询" class="x-m-l-20 x-m-r-5" @change="fHeadRadioChange">条件查询</el-radio>

        <el-input v-if="radio == '条件查询'" placeholder="机构,商户,备注" v-model="merInputVal" size="medium"
          style="width: 310px" class="x-m-r-12 x-flex-1">
          <el-button slot="append" @click="nowPage=1;init()">搜索</el-button>

        </el-input>
        <el-checkbox v-model="checked">模糊</el-checkbox>

      </div>
      <div class="x-flex">
        <el-button type="danger" size="medium" @click="fRegWxUser">增加商户</el-button>
      </div>
    </div>
    <el-card style="position: relative">
      <div style="height: calc(100vh - 198px)">
        <vxe-table border resizable highlight-hover-row height="100%" :data="tableData" align="center">
          <vxe-column field="RC" title="序号" width="50" fixed="left"></vxe-column>
          <vxe-column :field="item.sortType" :title="item.title" :min-width="item.width" v-for="item in tableJson"
            :key="item.id">
            <template #header>
              <div class="x-flex x-row-center w100p" @click="fHeadSort(item.sortType, 'asc')">
                <span>{{ item.title }}</span>
              </div>
            </template>
          </vxe-column>

          <vxe-column fixed="right" title="操作" width="100" style="margin-bottom: 20px">
              <template slot-scope="scope">
                <div class="x-flex">
                  <el-button type="text" size="mini" @click="fModify(scope.row)" class="x-m-r-10" style="color: #2c8ff2">
                    编辑
                  </el-button>
                  <el-button type="text" size="mini" @click="unBand(scope.row)" style="color: #2c8ff2">
                    删除
                  </el-button>
                </div>
              </template>
          </vxe-column>
        </vxe-table>
        <div style="position: absolute; bottom: 15px; left: 20px; z-index: 999">
          共 {{ TP }} 页 {{ TR }} 条
        </div>
        <el-pagination background layout="prev, pager, next" :total="Number(TR)" @current-change="fCurrentChange" :current-page="nowPage"
          style="position: absolute; bottom: 15px; right: 20px; z-index: 999">
        </el-pagination>
      </div>
    </el-card>
    <el-dialog :visible.sync="addOrEditAgent" width="600px" :show-close="false" :close-on-click-modal="false"
      class="add-dialog" top="8vh">
      <div class="dialog-title x-flex x-row-between x-m-t-20">
        <div class="x-font-15 f600">
          {{ smAiAddOrEdit == "ADD" ? "增加商户" : "修改商户" }}
        </div>
        <div class="x-flex">
          <el-button type="danger" size="small" @click="fSavesmAi">保存</el-button>
          <el-button type="info" size="small" @click="fClose">关闭</el-button>
        </div>
      </div>
      <!-- 机构编号  AI编码-->
      <div class="x-flex x-p-t-20 x-p-r-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r must x-w100">
          机构编号
        </div>
        <div class="x-flex-1">
          <el-input v-model="smFaceInfo.api_user_phone" :disabled="smAiAddOrEdit=='EDIT'?true:false"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r must x-w100">
          商户手机号
        </div>
        <div class="x-flex-1">
          <el-input v-model="smFaceInfo.mch_id" :disabled="smAiAddOrEdit=='EDIT'?true:false"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r must x-w100">
          商户店名
        </div>
        <div class="x-flex-1">
          <el-input v-model="smFaceInfo.mch_name"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r must x-w100">
          商户地址
        </div>
        <div class="x-flex-1">
          <el-input v-model="smFaceInfo.mch_adr"></el-input>
        </div>
        <!-- </div> -->
      </div>
      <div class="x-flex x-p-t-20 x-p-r-20 x-p-b-20">
        <!-- <div class="x-flex x-flex-1"> -->
        <div class="x-p-r-10 x-text-r x-w100">
          备注信息
        </div>
        <div class="x-flex-1">
          <el-input v-model="smFaceInfo.user_memo"></el-input>
        </div>
        <!-- </div> -->
      </div>

    </el-dialog>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        radio: "条件查询",
        merInputVal: "",
        // uploadImgValue:'',//上传的文件名称
        checked: true, //
        nowPage: 1, // 当前页数
        TR: 0, // 总条数
        TP: 0, // 总页数
        tableData: [],
        fileLise: [], //上传文件列表
        sortType: "", // 排序类型
        sortAscDesc: "", // 排序顺序
        tableJson: [{
            id: 7,
            title: "状态",
            width: "80",
            sortType: "state",
          }, {
            // 循环渲染数据
            id: 2,
            title: "机构编号",
            width: "120",
            sortType: "api_user_phone",
          },
          {
            id: 3,
            title: "商户手机号",
            width: "180",
            sortType: "mch_id",
          },
          {
            id: 4,
            title: "商户店名",
            width: "160",
            sortType: "mch_name",
          },
          {
            id: 5,
            title: "商户地址",
            width: "260",
            sortType: "mch_adr",
          },
          {
            id: 6,
            title: "备注",
            width: "240",
            sortType: "user_memo",
          },
          {
            id: 11,
            title: "修改人",
            width: "100",
            sortType: "chg_user_name",
          },
          {
            id: 12,
            title: "修改时间",
            width: "180",
            sortType: "chg_time",
          },

        ],
        addOrEditAgent: false, // 增加/修改用户
        smAiAddOrEdit: "ADD",
        smFaceInfo: {
          // ai_id: '',
          api_user_phone: '',
          mch_id: '',
          mch_name: '',
          // pos_id: '',
          mch_adr: '',
          user_memo: '',
          state: '未绑定',
        },


      };
    },
    created() {
      this.init();
    },
    methods: {
      async init() {
        let res = await this.fMchFaceManger('GET_LIST');


        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        this.TR = 0
        this.TP = 0
        if (res.data.length > 0) {
          this.TR = res.data[0].TR; //总条数
          this.TP = res.data[0].TP; //总页数
        }
        this.tableData = res.data;
      },

      async fModify(row) {
        this.smAiAddOrEdit = "EDIT";
        this.fileLise = []
        this.addOrEditAgent = true;
        // let res = await this.fMchFaceManger(
        //   "GET",
        //   row.user_phone
        // );
        // console.log(row.user_phone)

        // if (res.result != "sucess") {
        //   return this.$message(res.msg);
        // }
        this.smFaceInfo.api_user_phone = row.api_user_phone;
        this.smFaceInfo.mch_id = row.mch_id;
        this.smFaceInfo.mch_name = row.mch_name;
        this.smFaceInfo.mch_adr = row.mch_adr;
        this.smFaceInfo.user_memo = row.user_memo;
        this.smFaceInfo.state = row.state;

      },
      async unBand(row) {
        this.$confirm('是否确认删除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          confirmButtonClass: 'confirmButton',
        }).then(async () => {
          let res = await this.fMchFaceManger('DEL', row.ai_id, row.api_user_phone, row.mch_id, row.pos_id)
          if (res.result != 'sucess') {
            return this.$message(res.msg)
          }
          this.$message(res.msg)
          this.init()
        }).catch(() => {});
      },
      async fSavesmAi() {
        if (this.bykApi.smCom.fSmIsEmpty(this.smFaceInfo.api_user_phone)) {
          return this.$message("请输入机构号");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.smFaceInfo.mch_id)) {
          return this.$message("请输入商户手机号");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.smFaceInfo.mch_name)) {
          return this.$message("请输入商户店名");
        }
        if (this.bykApi.smCom.fSmIsEmpty(this.smFaceInfo.mch_adr)) {
          return this.$message("请输入商户地址");
        }
        let res = await this.fMchFaceManger(this.smAiAddOrEdit);

        if (res.result != "sucess") {
          return this.$message(res.msg);
        }
        if (this.smAiAddOrEdit == 'ADD') {
          this.$message(res.msg);
        } else {
          this.$message('修改成功');
        }
        this.init();
        this.fClose();
      },
      fClose() {
        this.addOrEditAgent = false;
        this.fileLise = []
        this.smFaceInfo = Object.assign({
          api_user_phone: '',
          mch_id: '',
          mch_name: '',
          mch_adr: '',
          user_memo: '',
          state: '未绑定',
        });
      },
      // 排序
      async fHeadSort(type, asc_desc = "") {
        // console.log(this.sortType, type);
        // console.log(type, asc_desc);
        if (this.sortAscDesc == asc_desc) {
          if (this.sortAscDesc == "asc") {
            this.sortAscDesc = "desc";
          } else {
            this.sortAscDesc = "asc";
          }
        } else {
          this.sortAscDesc = asc_desc;
        }
        this.sortType = type;
        this.init();
      },

      fHeadRadioChange(e) {},
      // fHeadSortChange(e) {
      //   this.searchSortVal = e[0];
      // },

      fRegWxUser() {
        this.smAiAddOrEdit = "ADD";
        this.addOrEditAgent = true;
        this.fileLise = []
      },
      // 分页
      async fCurrentChange(e) {
        this.nowPage = e
        let res = await this.fMchFaceManger('GET_LIST')

        if (res.result == "sucess") {
          this.tableData = res.data;
        } else {
          return this.$message(res.msg);
        }
      },

      async fUpLoadWxFile() {},



      //文件上传
      uploadOnChange(file, fileList) {},
      async fUploadFile(url) {},

      // ------------- 请求 开始 --------------

      async fMchFaceManger(oper, ai_id, api_user_phone, mch_id, pos_id) {
        let postJson = {};
        postJson["OPER"] = oper;
        postJson['MCH_ID'] = mch_id || this.smFaceInfo.mch_id
        postJson['MCH_NAME'] = this.smFaceInfo.mch_name
        postJson['CHG_USER_NAME'] = this.bykApi.global.fGetPlatform().partnerInfo.data.user_name
        postJson['PARTNER_PHONE'] = this.bykApi.global.fGetPlatform().partnerInfo.phone
        postJson['API_USER_PHONE'] = api_user_phone || this.smFaceInfo.api_user_phone
        postJson['API_APP_NAME'] = 'smFace'
        postJson['MCH_ADR'] = this.smFaceInfo.mch_adr
        postJson['USER_MEMO'] = this.smFaceInfo.user_memo
        postJson['STATE'] = ''
        postJson['SEARCH_STR'] = this.merInputVal
        postJson['PAGE_NO'] = this.nowPage
        postJson['PAGE_SIZE'] = 10
        postJson['ORDER_BY'] = ''

        let res = await this.bykApi.postApi.fPostToSmSellMainSrvApi("MCH_FACE_MANGER", postJson);

        return res;
      },
      // ------------- 请求 结束 --------------
    },
  };
</script>

<style lang='less' scoped>
  .smAi {
    .header {
      /deep/ .el-input-group__append {
        background-color: #409eff;
        color: #fff;
        border: 1px solid #409eff;
      }
    }

    .el-card {
      overflow: auto;
      position: relative;
      width: 100%;
      height: calc(100vh - 120px);
    }

    /deep/ .add-dialog .el-dialog__body {
      padding: 20px 30px 30px !important;
      // height: 600px;
      // overflow-y: scroll;
    }

    .add-dialog {
      .dialog-title {
        line-height: 17px;
        font-size: 14px;
        padding-left: 8px;
        padding-bottom: 15px;
        border-bottom: 1px solid #e6e6e6;
        position: relative;

        &::after {
          content: "";
          display: flex;
          width: 3px;
          height: 14px;
          position: absolute;
          left: 0;
          top: 8px;
          border-left: 3px solid #2c6ff2;
        }

        /deep/ .el-button--small {
          font-size: 14px;
          padding: 7px 15px;
        }
      }
    }

    .must {
      &::before {
        content: "*";
        color: #f76062;
        margin-right: 3px;
      }
    }

    .active {
      color: #679aff;
    }

    /deep/ .el-dialog .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog .el-dialog__body {
      padding: 18px;
    }

    //   /deep/ .el-button--default {
    //     border-radius: 0;
    //     border: 0;
    //     background-color: #f0f0f0;
    //     color: #808080;
    //     height: 45px;
    //   }
    /deep/ [class*=" el-icon-"],
    [class^="el-icon-"] {
      line-height: 0.5 !important;
      font-size: 14px;
    }

    /deep/ [class*=" el-icon-"]:hover,
    [class^="el-icon-"]:hover {
      color: #679aff;
      cursor: pointer;
    }

    //
  }

  .must1 {
    position: relative;
  }

  .must1:after {
    position: absolute;
    top: -4px;
    right: 2px;
    content: '*';
    color: red;
    font-size: 120%;
  }
</style>



// WEBPACK FOOTER //
// src/view/smFace.vue